module.exports = {
    "collectionLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`
};


//# sourceMappingURL=he-IL.main.js.map
